import { DOCUMENT, Inject, Injectable, inject } from '@angular/core';
import { pageMap } from '../routing/mapping/page-mapping';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { NavigationModel } from '../models/navigation/navigation.model';
import * as fromNavigationActions from '../state/navigation/navigation.actions';
import { ShiveRenderService } from './rendering/shive-render.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly renderer = inject(ShiveRenderService);
  private navigationModel: NavigationModel;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly location: Location,
    private readonly store: Store<NavigationModel>,
    private readonly router: Router,
  ) {
    this.initNavigationChanged();
  }

  public back(): void {
    void this.router.navigateByUrl(this.navigationModel.prevRoute);
  }

  private initNavigationChanged(): void {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      this.emitRouteData();
      this.setCSSHTMLClass();
    });
  }

  private emitRouteData(): void {
    const currentRoute = this.location.path().substring(1);
    const pageKey = pageMap.getPageKey(currentRoute);

    if (!pageKey) {
      return;
    }

    const pageTitle = pageMap.getTitle(pageKey);
    const prevPageKey = pageMap.getPreviousPage(pageKey);

    const navigationModel = new NavigationModel();
    navigationModel.pageTitle = pageTitle;

    if (prevPageKey) {
      navigationModel.prevRoute = pageMap.getRoute(prevPageKey);
      navigationModel.prevTitle = pageMap.getTitle(prevPageKey);
    }

    this.navigationModel = navigationModel;
    this.store.dispatch(
      fromNavigationActions.setNavigation({
        payload: navigationModel,
      }),
    );
  }

  private setCSSHTMLClass(): void {
    this.document.documentElement.classList.forEach((cssClass) => {
      this.renderer.removeClass(this.document.documentElement, cssClass);
    });
    this.renderer.addClass(this.document.documentElement, this.router.url.split('/')[1]);
  }
}
